<template>
  <v-snackbar
    v-model="isSnackbarVisible"
    top
    text
    :light="$vuetify.theme.dark"
    :color="status"
  >
    {{ content }}
    <template v-slot:action="{ attrs }">
      <v-btn
        icon
        :color="status"
        v-bind="attrs"
        @click="isSnackbarVisible = false"
      >
        <v-icon>{{ icons.mdiClose }}</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mdiClose } from '@mdi/js'
import {
  ref,
  onMounted,
  computed,
  inject,
} from '@vue/composition-api'

export default {
  setup() {
    // Initializers
    const store = inject('store')

    // Properties
    const isSnackbarVisible = ref(false)

    // Computed
    const content = computed(() => store.state.snackbar.content)
    const status = computed(() => store.state.snackbar.status)

    // Mounted
    onMounted(() => {
      store.subscribe(mutation => {
        if (mutation.type === 'SHOW_SNACKBAR') isSnackbarVisible.value = true
      })
    })

    return {
      // Properties
      isSnackbarVisible,

      // Computed
      content,
      status,

      // Icons
      icons: {
        mdiClose,
      },
    }
  },
}
</script>
